/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

/**
 * User: konstantin
 * Date: 4/23/14
 */
(function ($) {
    "use strict";
    /*globals Tc, doT, SCS, debug */
    /*jshint smarttabs:false */

    Tc.Module.Mainmenu = Tc.Module.extend({

        config: {},

        on: function (callback) {
            var mod = this;

            mod.handleMainMenuLi();

            callback();
        },

        handleMainMenuLi: function () {
            var $ctx = this.$ctx;
            $('.mainmenu > li', $ctx).hover(
                function () {
                    if (!scent.global.isMobile()) {
                        $(this).find('ul').stop().animate({
                            height: "120px"
                        }, 200);
                    }
                },
                function () {
                    if (!scent.global.isMobile()) {
                        $(this).find('ul').stop().animate({
                            height: "0px"
                        }, 200);
                    }
                }
            );

            $('.mainmenu > li', $ctx).click(function () {
                if (scent.global.isMobile()) {
                    $(this).find('ul li').slideToggle("slow");
                    $(this).siblings().find('ul li').slideUp("slow");
                    $(this).find('a[href^="http"]').on('click', handler);
                    return false;
                }
            });
        }

    });
}(Tc.$));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/emagazine/clientlibs/dialogue/js/modules/Tc.Module.Mainmenu.js
// module id = 103
// module chunks = 0